import {ArrowIcon} from '@prtimes-basis/icons';
import styles from './responsive-footer.module.css';
import {Link} from './link';
import {Dropdown} from './dropdown';
import {Sp} from './sp';
import {serviceData} from './data/service-data';
import {recommendData} from './data/recommend-data';
import {facebookData} from './data/facebook-data';
import {twitterData} from './data/twitter-data';
import {footerData} from './data/footer-data';

type WithLoading<T> = {isLoading: true} | {isLoading: false; value: T};

type Props = {
  readonly myPagePath: WithLoading<string | undefined>;
  readonly showLoginModal: () => void;
};

export function ResponsiveFooter({myPagePath, showLoginModal}: Props) {
  return (
    <>
      {/* width < 768px */}
      <Sp />

      {/* 768px <= width */}
      <footer className={styles.pcFooter}>
        <div className={styles.footerContent}>
          <div className={styles.listsWrapper}>
            <section className={styles.section}>
              <h2 className={styles.title}>ニュースリリース配信サービス</h2>
              <ul className={styles.list}>
                {serviceData.map((item) => (
                  <li key={item.text}>
                    <Link className={styles.listLink} href={item.href}>
                      {item.text}
                    </Link>
                  </li>
                ))}
                {(() => {
                  if (myPagePath.isLoading) {
                    return null;
                  }

                  return myPagePath.value === undefined ? (
                    <li key='ログイン'>
                      <button
                        type='button'
                        className={styles.listLink}
                        onClick={showLoginModal}
                      >
                        ログイン
                      </button>
                    </li>
                  ) : (
                    <li key='管理画面'>
                      <Link className={styles.listLink} href={myPagePath.value}>
                        管理画面
                      </Link>
                    </li>
                  );
                })()}
              </ul>
            </section>
            <section className={styles.recommendedServiceSection}>
              <h2 className={styles.title}>レコメンドサービス</h2>
              <ul className={styles.list}>
                {recommendData.map((item) => (
                  <li key={item.text}>
                    <Link
                      className={styles.listLink}
                      href={item.href}
                      isExternal={item.isExternal}
                    >
                      {item.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
            <section className={styles.snsSection}>
              <h2 className={styles.title}>PR TIMES公式SNS</h2>
              <ul className={styles.list}>
                <li>
                  <Link
                    isExternal
                    className={styles.listLink}
                    href='https://www.facebook.com/prtimes.jp'
                  >
                    公式Facebookページ
                  </Link>
                </li>
                <li>
                  <Dropdown data={facebookData}>
                    <span>Facebookカテゴリ</span>
                    <ArrowIcon variant='gray' direction='down' />
                  </Dropdown>
                </li>
                <li>
                  <Link
                    isExternal
                    className={styles.listLink}
                    href='https://twitter.com/PRTIMES_JP'
                  >
                    公式Xページ
                  </Link>
                </li>
                <li>
                  <Dropdown data={twitterData}>
                    <span>Xカテゴリ</span>
                    <ArrowIcon variant='gray' direction='down' />
                  </Dropdown>
                </li>
              </ul>
            </section>
          </div>

          <section className={styles.footerFooter}>
            <ul className={styles.footerList}>
              {footerData.map((item) => (
                <li key={item.text}>
                  <Link
                    className={styles.listLink}
                    href={item.href}
                    isExternal={item.isExternal}
                  >
                    {item.text}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
          <p className={styles.copyright}>
            Copyright &copy; PR TIMES Corporation All Rights Reserved.
          </p>
        </div>
      </footer>
    </>
  );
}
